<template>
  <div>
    <AppHeader />
    <main class="main-content">
      <router-view />
    </main>
    <AppFooter />
    <CookieConsent />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import CookieConsent from "./components/CookieConsent.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    CookieConsent,
  },
};
</script>

<style>
@import './styles.css';

.main-content {
  padding-top: 70px; /* Espacio para el header fijo */
}
</style>